import './EventMeta.css';

function EventMeta({ date, dateEnd, hourStart, hourEnd, place, host }) {
  const [day, month, year] = date.split('/').map(Number);
  const dateObj = new Date(year, month - 1, day);

  const [dayEnd, monthEnd, yearEnd] = dateEnd.split('/').map(Number);
  const dateEndObj = new Date(yearEnd, monthEnd - 1, dayEnd);

  return (
    <div className="event-meta-grid">
      <div className="meta-item">
        <i className="fa-regular fa-calendar"></i>
        <div>
          <strong>Data</strong>
          <p>{dateObj.toLocaleDateString('it-IT', { 
            weekday: 'long',
            day: 'numeric', 
            month: 'long', 
            year: 'numeric' 
          })}</p>
          {dateEnd && (
            <p className="date-end">fino al {dateEndObj.toLocaleDateString('it-IT', { 
              day: 'numeric', 
              month: 'long', 
              year: 'numeric' 
            })}</p>
          )}
        </div>
      </div>
      <div className="meta-item">
        <i className="fa-regular fa-clock"></i>
        <div>
          <strong>Orario</strong>
          <p>{hourStart}{hourEnd && ` - ${hourEnd}`}</p>
        </div>
      </div>
      <div className="meta-item">
        <i className="fa-solid fa-location-dot"></i>
        <div>
          <strong>Luogo</strong>
          <p>{place}</p>
        </div>
      </div>
      <div className="meta-item">
        <i className="fa-regular fa-user"></i>
        <div>
          <strong>Organizzatore</strong>
          <p>{host}</p>
        </div>
      </div>
    </div>
  );
}

export default EventMeta;
